import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { systemRemoveDialog } from '../../store/system/slice';
import ButtonGroup from '../ButtonGroup';
import SimpleButton from '../SimpleButton';
import { Actions, Container, Content, Message, Title } from './styles';

const Dialogs: React.FC = () => {
    const dialogs = useSelector((state: IApplicationState) => state.system.dialogs);

    const dispatch = useDispatch();

    if(dialogs.length === 0) return null;

    const dialog = dialogs[0];

    return <Container>
        <Content>
            {dialog.title !== undefined && <Title>{dialog.title}</Title>}
            <Message>{dialog.message}</Message>
            <Actions>
                <ButtonGroup>
                    {dialog.actions.map((action, index) => <SimpleButton 
                        key={`dialog-${dialog.id}-action-${index}`} 
                        color={action.color} 
                        prependIcon={action.prependIcon} 
                        appendIcon={action.appendIcon} 
                        onClick={() => {
                            dispatch(systemRemoveDialog(dialog.id))
                            action.action();
                        }}
                    >{action.text}</SimpleButton>)}
                </ButtonGroup>
            </Actions>
        </Content>
    </Container>
}

export default Dialogs;